import { render, staticRenderFns } from "./BasicDashboardInquires.vue?vue&type=template&id=bc222674&lang=true"
import script from "./BasicDashboardInquires.vue?vue&type=script&lang=js"
export * from "./BasicDashboardInquires.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports